const EcoSalivaThemeVariables: Record<string, any> = {
  manufacturer: 'Eco Diagnóstica',
  pageTitle: 'WebApp - Autoteste COVID Ag ORAL Detect ECO Diagnóstica',
  backgroundDisableButton: '#d9e9e2',
  backgroundBase: '#50A551',
  backgroundBaseFilter:
    "invert(57%) sepia(53%) saturate(454%) hue-rotate(72deg) brightness(89%) contrast(89%)",
  backgroundBaseGradient: "#3cf43e",
  backgroundDaxQRCode: "linear-gradient(to right, #50A551, #3cf43e, #50A551)",
  ResultShareModal: "#50A551",
  ResultShareModalTitle: "#FFFF",
  backgroundShareResult: "#F7FCFA",
  backgroundLoaderResult: "linear-gradient(180deg, #61E863 0%, #5AAE5C 100%)",
  backgroundLoaderAnimationStepA:
    "linear-gradient(180deg, #61E863 0%, #5AAE5C 100%)",
  backgroundLoaderAnimationStepB:
    "linear-gradient(180deg, #61E863 0%, #5AAE5C 100%)",
  backgroundLoaderAnimationStepC:
    "linear-gradient(180deg, #61E863 0%, #5AAE5C 100%)",
  backgroundLoaderBar:
    "linear-gradient(90deg, rgba(80, 165, 81, 0) 0%, #50A551 45.16%, rgba(80, 165, 81, 0) 100%)",
  backgroundShareScreen: "#F7FCFA",
  backgroundStrongBase: "#0F8722",
  urlTest:
    "https://ecodiagnostica.com.br/diagnostico-rapido/autoteste-covid-ag-oral-detect/",
  urlPathLoaderFile: "eco/loader-logo.png",
  urlPathLogoFile: "eco/eco-logo.png",
  urlFavicon: "eco/favicon.png",
  logoWidth: "102.74px",
  logoHeight: "50px",
  urlPathLogoFileWhiteHeader: "eco/eco-logo-white.png",
  urlPathLogoFileWhite: "eco/eco-logo.png",
  urlPathLogoResult: "eco/eco-logo.png",
  urlPathLogoFileCrx: "clinicarx-logo-green.svg",
  logoWidthWhite: "75px",
  logoHeightWhite: "36.5px",
  logoWidthResult: "75px",
  logoHeightResult: "36.5px",
  logoWhiteTopMargin: "20px",
  logoWidthWhiteDask: "156px",
  logoHeightWhiteDask: "80px",
  testName: "Autoteste COVID Ag ORAL Detect Eco Diagnóstica",
  urlPathTestImage: "eco/eco-saliva-test.png",
  urlPathDocumentIcon: "eco/card-result.png",
  urlVideoGuidelines: "https://www.youtube.com/embed/nkZy-8I7S6I",
  urlPathQRCode: "eco/eco-saliva-qr-code.jpg",
  socialShareInfo:
    "Acabei de gerar o cartão de resultado do meu Autoteste COVID Ag Detect da ECO Diagnóstica. Fazer o autoteste é cuidar de você e de quem você ama.",
  totalSteps: 8,
  testStepOneContents: {
    title: "Colete a amostra:",
    steps:
      "<ol> <li>Puxe sua saliva ao menos 3 vezes;</li><li>Cuspa a saliva no copo de coleta de amostra;</li>  <li>Com as mãos higienizadas, pegue o cotonete (swap) e gire ele 10 vezes dentro do copo que contém a saliva, misturando bem a amostra coletada.</li></ol>",
    image: "eco/step-one-saliva.png",
    warningActive: true,
    warningText:
      "Não toque com a sua mão na ponta de algodão do cotonete (swab).",
  },
  testStepTwoContents: {
    title: "Prepare sua amostra para o teste:",
    steps:
      "<ol><li>Pegue o tubo com liquido de diluição;</li><li>Retire o lacre do tubo;</li><li>Insira o swab no tubo;</li><li>Gire o swab nasal pelo menos 10 vezes.</li></ol>",
    image: "eco/nasal/2-prepare.gif",
    warningActive: true,
    warningText:
      "Caso ocorra contato da solução com sua pele ou olhos, lave imediatamente com água.",
  },
  testStepThreeContents: {
    title: "Pingue as gotas no dispositivo:",
    steps:
      "<ol><li>Coloque a tampa conta gotas no tubo;</li><li>Abra o sachê de alumínio e retire o dispositivo teste;</li><li>Pingue 4 gotas da mistura no poço de amostra do dispositivo de teste.</li></ol>",
    image: "eco/nasal/3-drop.gif",
    warningActive: true,
    warningText:
      "Atenção com a contagem das gotas. Não aplique mais de 4 gotas.",
    timerInMinutes: 15,
  },
  testStepEightContents: {
    title: "Informe os demais dados pessoais",
    warningText:
      "Utilizamos o CPF para reforçar sua identidade no cartão de resultado compartilhável do teste e para seu cadastro com a Clinicarx.",
  },
  logoViewResultCardHeight: '30px',
  logoViewResultCardWidth: '60px',
  testStepFourContents: {
    title: "Informe o resultado do autoteste",
    warningText:
      'A intensidade da cor das linhas no dispositivo podem variar e mesmo os tons mais claros devem ser considerados. <span id="modalLink" style="color: #006ba6; text-decoration: underline;"> Clique aqui se o resultado não mostra a linha “C”.</span>',
  },
  testStepFiveContents: {
    title: "Tire uma foto do resultado do autoteste",
    warningText:
      '<span id="modalLink" style="color: #006ba6; text-decoration: underline;">Ver instruções e exemplo de como tirar a foto.</span>',
  },
  backgrounBaseLinear:
    "linear-gradient(207.44deg, #50A551 13.84%, #5AD35B 41.11%, #50A551 89.05%)",

  // Result image variables
  urlNegativeWithoutSymptomsImage: "eco/eco-negative-without-symptons.png",
  heightNegativeWithoutSymptomsImage: "173px",
  widthNegativeWithoutSymptomsImage: "173px",
  urlNegativeWithSymptomsImage: "eco/eco-negative-with-symptons.png",
  heightNegativeWithSymptomsImage: "124px",
  widthNegativeWithSymptomsImage: "122px",
  urlPositiveWithoutSymptomsImage: "eco/eco-positive-without-symptons.png",
  heightPositiveWithoutSymptomsImage: "121px",
  widthPositiveWithoutSymptomsImage: "173px",
  urlPositiveWithSymptomsImage: "eco/eco-positive-with-symptons.png",
  heightPositiveWithSymptomsImage: "124px",
  widthPositiveWithSymptomsImage: "150px",
};

export { EcoSalivaThemeVariables };
